import React from 'react';
import classNames from 'classnames';
import {Grid} from 'components/MarketingAssets';

export interface ShopsEmptyProps extends React.HTMLProps<HTMLDivElement> {
  heading: React.ReactNode;
}

const style = {
  section: 'section',
  sectionTight: 'section--tight',
  sectionHeading: 'section-heading',
  sectionHeadingLeft: 'section-heading--left',
  h2: 'section-heading__subhead heading--2',
  h3: 'section-heading__subhead heading--3',
  smartSearch: 'smart-search__zero-results',
};

export function ShopsEmpty({
  heading,
  children,
}: ShopsEmptyProps) {
  return (
    <Grid>
      <section className={classNames(style.section, style.sectionTight, style.smartSearch)}>
        <div className={classNames(style.sectionHeading, style.sectionHeadingLeft)}>
          <h2 className={style.h2}>{heading}</h2>
          <div className={style.h3}>{children}</div>
        </div>
      </section>
    </Grid>
  );
}

export default ShopsEmpty;

